import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcoHanger = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 54,
	height: 40,
	viewBox: "0 0 54 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5.12699 28.7336L21.8012 21.9805C23.4538 21.3112 25.1256 21 27 21C28.8744 21 30.5462 21.3112 32.1988 21.9805L48.873 28.7336C50.8046 29.5159 52 30.9875 52 32.5832C52 35.0225 49.2535 37 45.8655 37H8.13448C4.7465 37 2 35.0225 2 32.5832C2 30.9875 3.19538 29.5159 5.12699 28.7336Z",
		stroke: "#9095B5",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21 7.17007C21 4.31472 23.4624 2 26.5 2C29.5376 2 32 4.31472 32 7.17007C32 9.12373 30.8472 10.8243 29.1462 11.7035C27.8007 12.3989 26.5 13.5554 26.5 15.0544V21",
		stroke: "#9095B5",
		strokeWidth: 2,
		strokeLinecap: "round"
	})]
});
export default SvgIcoHanger;
